import { currentAppBrand, appBrands } from '..';
import { allFeaturesAtFalse } from './default';
import { features as aladinFeatures } from './aladin';
import { features as farmiFeatures } from './farmi';
import { features as episensFeatures } from './episens';
import { features as umgUsFeatures } from './umg-us';
function featuresForBrand(appBrand) {
    switch (appBrand) {
        case appBrands.Aladin:
            return aladinFeatures;
        case appBrands.Farmi:
            return farmiFeatures;
        case appBrands.Episens:
            return episensFeatures;
        case appBrands.UMG_US:
            return umgUsFeatures;
        default:
            return allFeaturesAtFalse;
    }
}
export const featuresForCurrentBrand = featuresForBrand(currentAppBrand);
//# sourceMappingURL=index.js.map